export function validateRespondSelection(
    selectedTickets,
    responseCodes,
    isSType
) {
    // Different types of tickets may have different response code lists associated with them.
    // So for example, if you have a design ticket and a regular ticket selected, you can't
    // batch respond to both at the same time.  This function checks for that and returns an
    // error message if there is a problem.  If there is no problem, it returns null.

    // We need to take into account the following buckets that a ticket may fall into:
    // 1.  Cancelled (if the ticket is a cancel ticket or if it is a regular ticket that has been cancelled)
    // 2.  Design (if the ticket is a design ticket)
    // 3.  Complex Project (if the ticket is a complex project ticket [PA811])
    // 4.  Non-Design (if the ticket is a regular ticket that is not cancelled)

    if(selectedTickets.length === 1) {
        return null; // no need to validate a single ticket
    }

    const stats = {
        center_state: []
    };
const partition = {
        cancelled: [],
        design: [],
        complex: [],
        regular: []
    };
    
    for (let ticket of selectedTickets) {
        // parition the tickets into the buckets above
        if (ticket.TS_cancelled) {
            partition.cancelled.push(ticket);
        } else if (isSType('design', ticket)) {
            partition.design.push(ticket);
        } else if (isSType('complex_project', ticket)) {
            partition.complex.push(ticket);
        } else {
            partition.regular.push(ticket);
        }
        // keep track of the centers and states of the tickets (eg, "NC811-NC", "USAN-NV", "USAN-CA")
        if (!stats.center_state.includes(ticket.center + '-' + ticket.state)) {
            stats.center_state.push(ticket.center + '-' + ticket.state);
        }
    }

    // determine if company has any design response codes
    let haveDesignOnlyResponseCodes = false;
    let haveComplexProjectOnlyResponseCodes = false;
    for (let companyResponseCode of responseCodes) {
        if (companyResponseCode.design) {
            haveDesignOnlyResponseCodes = true;
        }
        if (companyResponseCode.complex_project) {
            haveComplexProjectOnlyResponseCodes = true;
        }
    }

    if (stats.center_state.length > 1) {
        // Selected tickets includes multiple centers; can't mix/match
        return 'There are tickets from multiple Centers and/or States selected.  You may only batch respond to one Center and State at a time.';
    }

    if (partition.cancelled.length  && partition.cancelled.length < selectedTickets.length) {
        // We have at least 1 but not ALL canceleld tickets; can't mix/match
        return 'There are both Cancelled and Non-Cancelled tickets selected.  You may only batch respond to one type at a time.';
    }
    if (haveDesignOnlyResponseCodes && partition.design.length && partition.design.length < selectedTickets.length) {
        // Respoding Disabled for current Ticket Selection.  There are both Design and regular tickets selected.  You may only batch repond to one type at a time.
        return 'There are both Design and regular tickets selected.  You may only batch respond to one type at a time.';
    }
    if (haveComplexProjectOnlyResponseCodes && partition.complex.length  && partition.complex.length < selectedTickets.length) {
        // We have at least 1 but not ALL canceleld tickets; can't mix/match
        return 'There are both Complex Project and Non-Complex Project tickets selected.  You may only batch respond to one type at a time.';
    }
    // Passes
    return null;
}
